import { render, staticRenderFns } from "./MyPanelTasks.vue?vue&type=template&id=12432a7c"
import script from "./MyPanelTasks.vue?vue&type=script&lang=js"
export * from "./MyPanelTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports